import client from "./client";

const _triggerDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const bladesApi = {
  list: (projectId) => client.get("/blades", { params: { project_id: projectId } }),
  search: (q, excludeProjectId) =>
    client.get("/blades/search", { params: { q, exclude_project: excludeProjectId } }),
  get: (id) => client.get(`/blades/${id}`),
  lineage: (id) => client.get(`/blades/${id}/lineage`),
  create: (data) => client.post("/blades", data),
  update: (id, data) => client.put(`/blades/${id}`, data),
  remove: (id) => client.delete(`/blades/${id}`),
  release: (id) => client.patch(`/blades/${id}/release`),
  unrelease: (id) => client.patch(`/blades/${id}/unrelease`),
  checkout: (id) => client.post(`/blades/${id}/checkout`),
  checkin:  (id) => client.post(`/blades/${id}/checkin`),

  saveConstructionLines: (id, lines) =>
    client.put(`/blades/${id}/construction_lines`, { construction_lines: lines }),

  importXml: (id, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return client.post(`/blades/${id}/import-xml`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  exportXmlUrl: (id) => `/api/blades/${id}/export-xml`,

  downloadXml: async (id, name) => {
    const { data } = await client.get(`/blades/${id}/export-xml`, { responseType: "blob" });
    _triggerDownload(data, `${name}_geomInput.xml`);
  },
  downloadMeridionalCsv: async (id, name, header = false) => {
    const { data } = await client.get(`/blades/${id}/export-meridional-csv`, { responseType: "blob", params: { header: header ? 1 : 0 } });
    _triggerDownload(data, `${name}_meridional.zip`);
  },
  downloadProfilesCsv: async (id, name, header = false) => {
    const { data } = await client.get(`/blades/${id}/export-profiles-csv`, { responseType: "blob", params: { header: header ? 1 : 0 } });
    _triggerDownload(data, `${name}_profiles.zip`);
  },
  downloadStep: async (id, name) => {
    const { data } = await client.get(`/blades/${id}/export-step`, { responseType: "blob" });
    _triggerDownload(data, `${name}_blade.stp`);
  },
  downloadGeomTurbo: async (id, name) => {
    const { data } = await client.get(`/blades/${id}/export-geomturbo`, { responseType: "blob" });
    _triggerDownload(data, `${name}.geomTurbo`);
  },
  beta1Init: (id) => client.get(`/blades/${id}/beta1-init`),
  performanceCoefficients: (id) => client.get(`/blades/${id}/performance-coefficients`),
};

export const geometryApi = {
  bladeViews:    (id) => client.get(`/geometry/blade/${id}/views`),
  curvatureMap:  (id) => client.get(`/blades/${id}/curvature`),
  evaluateBspline: (degree, controlPoints, nPoints = 100) =>
    client.post("/geometry/bspline/evaluate", { degree, control_points: controlPoints, n_points: nPoints }),

  fitBspline: (degree, dataPoints, nControlPoints) =>
    client.post("/geometry/bspline/fit", { degree, data_points: dataPoints, n_control_points: nControlPoints }),

  impellerInit: (params) => client.post("/geometry/impeller/init", params),

  predictParams: (params) => client.post("/geometry/impeller/predict", params),

  trainModel: (dataset) => client.post("/geometry/impeller/train", { dataset }),

  computeMeridCont: (data) => client.post("/geometry/meridcont/compute", data),
};
